const Layout = () => import('@/layout/index.vue')

export default {
    path: '/permission',
    component: Layout,
    redirect: '/permission/customer',
    name: 'Permission',
    meta: {
        title: '权限管理',
        icon: 'permission',
        auth: ['Permission']
    },
    children: [
        {
            path: 'menu',
            name: 'PermissionMenu',
            component: () => import('@/views/permission/menu/index.vue'),
            meta: {
                title: '菜单管理',
                icon: 'permission-menu',
                auth: ['PermissionMenu']
            }
        },
        {
            path: 'role',
            name: 'PermissionRole',
            component: () => import('@/views/permission/role/index.vue'),
            meta: {
                title: '角色管理',
                icon: 'permission-role',
                auth: ['PermissionRole']
            }
        },
        {
            path: 'user',
            name: 'PermissionUser',
            component: () => import('@/views/permission/user/index.vue'),
            meta: {
                title: '用户管理',
                icon: 'permission-user',
                auth: ['PermissionUser']
            }
        },
        {
            path: 'log',
            name: 'PermissionLog',
            component: () => import('@/views/permission/log/index.vue'),
            meta: {
                title: '操作日志',
                icon: 'permission-log',
                auth: ['PermissionLog']
            }
        }

    ]
}
